import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../../ReusableBlocks/Navbar';
import PageHeader from '../Components/shared/PageHeader';
import PartnerLayout from '../Layout/PartnerLayout';
import { usePartnerRoleAccess } from '../Hooks/usePartnerRoleAccess';

const NotAuthorizedPage = () => {
  const access = usePartnerRoleAccess();

  return (
    <>
      <Navbar activeTab="PARTNER_PORTAL" />
      <PartnerLayout access={access}>
        <PageHeader
          title="Access restricted"
          description="You do not have permission to view this Partner Portal page."
        />
        <div className="card partner-card partner-access-card">
          <div className="card-body">
            <h3>Need access?</h3>
            <p>Contact your administrator if you believe you should have access to this area.</p>
            <Link className="btn btn-primary" to="/home">Go to home</Link>
          </div>
        </div>
      </PartnerLayout>
    </>
  );
};

export default NotAuthorizedPage;
